export default "__VITE_ASSET__BWhwODsM__"